import {
  FormControl,
  type FormControlLabelProps,
  FormLabel,
  Slider,
  type SliderProps,
} from "@mui/material";
import type { CSSProperties } from "react";
import { Controller, type FieldValues, type Path, useFormContext } from "react-hook-form";
import { type ElementTracking, useElementTracking } from "../../../analytics/analytics";

interface Props<TFieldValues extends FieldValues> {
  name: Path<TFieldValues>;
  label?: string;
  labelPlacement?: FormControlLabelProps["labelPlacement"];
  formControlStyle?: CSSProperties;
}

export const CeSlider = <TFieldValues extends FieldValues>({
  name,
  label,
  formControlStyle,
  analyticsCategory,
  ...sliderProps
}: Props<TFieldValues> & SliderProps & ElementTracking): React.JSX.Element => {
  const { control } = useFormContext<TFieldValues>();
  const analyticsProps = useElementTracking(analyticsCategory, name, "slider");

  return (
    <Controller
      name={name}
      control={control}
      render={({ field }) => (
        <FormControl style={formControlStyle}>
          <FormLabel id={`${name}-label`}>{label}</FormLabel>
          <Slider
            id={`${name}-slider`}
            onChange={field.onChange}
            value={field.value}
            valueLabelFormat={(val) => `${val}px`}
            valueLabelDisplay="auto"
            aria-labelledby="label-padding"
            slotProps={{
              input: analyticsProps,
            }}
            {...sliderProps}
          />
        </FormControl>
      )}
    />
  );
};
